import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { sendContact } from "../lib/api";
import { toast } from "sonner";

const Contact = () => {
    const [search] = useSearchParams();
    const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);

    useEffect(() => {
        const subj = search.get("subject");
        if (subj) {
            setForm((f) => ({ ...f, subject: subj }));
        }
    }, [search]);

    const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) return;
        setBusy(true);
        try {
            await sendContact(form);
            setSent(true);
            toast.success("Thank you. We'll be in touch.");
            setForm({ name: "", email: "", subject: "", message: "" });
        } catch (_e) {
            toast.error("Something went quietly wrong. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="contact-page" className="bg-[#FAF9F6]">
            <section className="py-20 lg:py-28 px-6 lg:px-10">
                <div className="max-w-4xl mx-auto">
                    <p className="label">Contact</p>
                    <h1 className="font-serif text-5xl sm:text-6xl mt-5 leading-[1.04]">
                        Say hello.
                    </h1>
                    <p className="mt-8 max-w-xl text-lg text-[#4A4A46] leading-relaxed">
                        Questions about a bar, wholesale, or a custom gift box? We&rsquo;d love
                        to hear from you.
                    </p>
                </div>
            </section>

            <section className="px-6 lg:px-10 pb-32">
                <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    <aside className="lg:col-span-4 space-y-10">
                        <div>
                            <p className="label">Email</p>
                            <p className="mt-3 text-[#1C1C1A]">hello@alati.com.au</p>
                        </div>
                        <div>
                            <p className="label">Studio</p>
                            <p className="mt-3 text-[#1C1C1A] leading-relaxed">
                                Darwin
                                <br />
                                Northern Territory, Australia
                            </p>
                        </div>
                        <div>
                            <p className="label">Hours</p>
                            <p className="mt-3 text-[#1C1C1A] leading-relaxed">
                                Monday &ndash; Friday
                                <br />
                                9am &ndash; 4pm ACST
                            </p>
                        </div>
                        <div>
                            <p className="label">Wholesale</p>
                            <p className="mt-3 text-[#4A4A46] leading-relaxed text-sm">
                                We&rsquo;re selective about stockists. If you run a beautifully
                                considered store, please write to us.
                            </p>
                        </div>
                    </aside>

                    <form
                        onSubmit={onSubmit}
                        className="lg:col-span-8 space-y-8"
                        data-testid="contact-form"
                    >
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                            <div>
                                <label className="label">Name</label>
                                <input
                                    className="alati-input mt-3"
                                    type="text"
                                    value={form.name}
                                    onChange={update("name")}
                                    required
                                    data-testid="contact-name"
                                />
                            </div>
                            <div>
                                <label className="label">Email</label>
                                <input
                                    className="alati-input mt-3"
                                    type="email"
                                    value={form.email}
                                    onChange={update("email")}
                                    required
                                    data-testid="contact-email"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="label">Subject</label>
                            <input
                                className="alati-input mt-3"
                                type="text"
                                value={form.subject}
                                onChange={update("subject")}
                                data-testid="contact-subject"
                            />
                        </div>
                        <div>
                            <label className="label">Message</label>
                            <textarea
                                className="alati-input mt-3 resize-none"
                                rows="6"
                                value={form.message}
                                onChange={update("message")}
                                required
                                data-testid="contact-message"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={busy}
                            className="btn-primary"
                            data-testid="contact-submit"
                        >
                            {busy ? "Sending" : "Send Message"}
                        </button>

                        {sent && (
                            <p
                                className="text-sm text-[#6A7059]"
                                data-testid="contact-success"
                            >
                                Thank you. We&rsquo;ll be in touch.
                            </p>
                        )}
                    </form>
                </div>
            </section>
        </div>
    );
};

export default Contact;
